import * as React from "react";
import { ModelState } from "../../../Models/ModelStateEnum";
import EightWingsServiceableCreate from "./EightWingsServiceableCreate";
import EightWingsServiceableUpdate from "./EightWingsServiceableUpdate";
// import EightWingsServiceableView from './EightWingsServiceableView';

const EightWingsServiceable = props => {
  const [tabType, setTabType] = React.useState(ModelState.Create);
  React.useEffect(() => {
    var tempTabType = props?.requestServiceableData === null ? ModelState.Create : ModelState.Edit;
    setTabType(tempTabType);
  }, [props?.requestServiceableData]);
  switch (tabType) {
    case ModelState.Create:
      return (
        <EightWingsServiceableCreate
          requestId={props.requestId}
          eightWingsId={props?.eightWingsId}
          requestDetail={props?.requestDetailData}
          finalCallBack={e => props.parentCallBack()}
        />
      );
    case ModelState.Edit:
      return (
        <EightWingsServiceableUpdate
          serviceable={props.requestServiceableData}
          requestDetail={props?.requestDetailData}
          finalCallBack={e => props.parentCallBack()}
          requestId={props.requestId}
          eightWingsId={props?.eightWingsId}
          eightWingsStatus={props?.eightWingsStatus}
        />
      );
    default:
      return <></>;
  }
};

export default EightWingsServiceable;
